import $ from 'jquery'; 
import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css'

function taxArcJS(){
  //console.log('tax archive code');
  
    const outputContainer = $('#output');
    const loadMoreContainer = $('#load-more');
    const recipeGallery = $('#ajaxRecipeGallery .keen-slider');
    const numbertoshow = $('.TaxonomyArchive').attr('initLoad');
    const tax = $('.TaxonomyArchive nav ul').attr('data-taxonomy');

    $('document').ready(function(){
      //console.log('user_selection');
      userSelection();
    });
    $(window).resize(function(){
      //console.log('hello');
      $('#output figure img').css('height','');
      setImageHeights($('#output figure img'));
      //fixHeight();
    }).resize();

    //Load user selection from taxonomy grid block
    // if not selection, click the second button
    //
    function userSelection(){
      let selection = localStorage.getItem('archive-selection_'+tax);
      //console.log(selection);
      if(selection != null){
        localStorage.removeItem('archive-selection_'+tax);
        //console.log('what i see');
        //console.log($('.TaxonomyArchive nav li[data-term="'+selection+'"'));
        //console.log($('.TaxonomyArchive nav li[data-term="'+selection+'"')[0]);
        $('.TaxonomyArchive nav li[data-term="'+selection+'"]').click();
      } else {
        //Chooses first option to populate based on the page
        if(tax == 'protein_type'){
          $('.TaxonomyArchive nav li:first-child').click();
        } else {
          $('.TaxonomyArchive nav li:nth-child(5)').click();
        }
      }
    }

    ///Ajax - Filter selection
    $('.TaxonomyArchive #filters > ul').on('click','li:not(.disabled)',function(){
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      outputContainer.toggleClass('loading');
      //console.log('clicked filter');
      //console.log($(this)[0]);
      $.ajax({
        type: 'POST',
        url: wpVars.ajaxURL,
        data: {
          action: 'get_posts_by_taxonomy',
          taxonomy: 'special-filter',
          term: $(this).attr('data-term'),
          category: $('.TaxonomyArchive > nav > ul > li.active').attr('data-term'),
          numbertoshow: numbertoshow
        },
        success: function(response) {
          // Handle the response from the server
          //console.log('Done fetching Products');
          //console.log(response);
          outputContainer.empty();
          loadMoreContainer.empty();
          printOutput(response);
          //updateRecipeGallery(taxonomy,term);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          // Handle any errors that occur
          console.error('AJAX error: ' + textStatus, errorThrown);
        }
      });
    });

    function fetchSpecial(type){
      $('.TaxonomyArchive #filters > ul > li').addClass('disabled');
      if(type == 'extrastips'){
        $.ajax({
          type: 'POST',
          url: wpVars.ajaxURL,
          data: {
            action: 'get_posts_by_taxonomy',
            taxonomy: 'special',
            term: 'post',
            numbertoshow: numbertoshow
          },
          success: function(response) {
            // Handle the response from the server
            //console.log('Done fetching Products');
            //console.log(response);
            outputContainer.empty();
            loadMoreContainer.empty();
            printOutput(response);
            //updateRecipeGallery(taxonomy,term);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            // Handle any errors that occur
            console.error('AJAX error: ' + textStatus, errorThrown);
          }
        });
      }
    }

    //Ajax - Taxonomy Selection
    $('.TaxonomyArchive > nav > ul').on('click','li',function(){
      let selection = $(this).attr('data-term');
      localStorage.setItem('archive-selection_'+tax,String(selection));
      //Navbar changes
      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      //Filter changes
      $('.TaxonomyArchive #filters > ul > li').removeClass('active');
      $('.TaxonomyArchive #filters > ul > li').removeClass('disabled');

      outputContainer.toggleClass('loading');
      //SPECIAL CASE
      if($(this).attr('special') !== undefined){
        //console.log('special');
        fetchSpecial($(this).attr('special'));
        return
      }
      //console.log('normal');
      ///Get query parameters and post
      //Fetch filtered or unfiltered depending on precense of li.active
      if ($('.TaxonomyArchive #filters > ul > li.active').length == 1){
        $('.TaxonomyArchive #filters > ul > li.active').click();
      } else {
        let term = $(this).attr('data-term');
        //console.log('Fetch Products');
        $.ajax({
            type: 'POST',
            url: wpVars.ajaxURL,
            data: {
              action: 'get_posts_by_taxonomy',
              taxonomy: tax,
              term: term,
              numbertoshow: numbertoshow,
              orderBy: (tax == 'category_type') ? 'rand' : 'none',
            },
            success: function(response) {
              // Handle the response from the server
              //console.log('Done fetching Products');
              //console.log(response);
              outputContainer.empty();
              loadMoreContainer.empty();
              printOutput(response);
              updateRecipeGallery(tax,term);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              // Handle any errors that occur
              console.error('AJAX error: ' + textStatus, errorThrown);
            }
          });
      }
    });

    //Load More Ajax button
    function ajax_loadMore(button){
      button.text('Loading...');
      outputContainer.toggleClass('loading');
      let load_ids = JSON.parse(button.attr('data-ids'));
      //console.log('Aftert ME!');
      //console.log(load_ids);
      let post_ids = load_ids.splice(0,numbertoshow);
      //console.log(load_ids);
      //console.log(post_ids);
      $.ajax({
        type: 'POST',
        url: wpVars.ajaxURL,
        data: {
          action: 'hydrate_posts',
          parameters: 'featured_image,title,permalink,flair,reviews',
          post_ids: JSON.stringify(post_ids)
        },
        success: function(response) {
          // Handle the response from the server
          if(load_ids.length > 0){
            button.attr('data-ids',JSON.stringify(load_ids));
            button.text('Load More');
          } else {
            button.remove();
          }
          // //console.log('Response->');
          // //console.log(response);
          printOutput(response);
        
        },
        error: function(jqXHR, textStatus, errorThrown) {
          //console.log(jqXHR);
          // Handle any errors that occur
          console.error('AJAX error: ' + textStatus, errorThrown);
        }
      });
      }

    //Print posts into #output
    function printOutput(response){
        //console.log('printOutput');
        let loadMore = [];
        let html = [];
        let flairHtml = [];
        //let flairStyle = '';
        response.forEach(item => {
          if (typeof item === "object"){
            if(item.flair == null){
              html.push(getItemString(item,outputContainer.attr('data-posttype')));
            } else {
              flairHtml.push(getItemString(item,outputContainer.attr('data-posttype')));
            }
          } else {
              loadMore.push(item); 
          }
        });

        if(!$.isEmptyObject(flairHtml)){
          flairHtml.forEach(html => {
            outputContainer.append(html);
          })
        }

        if(!$.isEmptyObject(html)){
          html.forEach(html => {
            outputContainer.append(html);
          })
        }

        setImageHeights($('#output figure img'));
        //console.log('Load morrrre->');
        //console.log(loadMore);
        if(!$.isEmptyObject(loadMore)){
          let newButton = $(`<button class="button button--dark_green" data-ids="` + JSON.stringify(loadMore) + `">Load More</button>`);
          loadMoreContainer.append(newButton);
          newButton.on('click',function(){ajax_loadMore($(this));});
        }
        //console.log('removeClass');
        outputContainer.removeClass('loading');
        
    }

    //Update recipe gallery
    function updateRecipeGallery(taxonomy,term){
        //console.log('updateRecipeGallery');
        if(recipeGallery.length == 0){
          return
        }
        recipeGallery.toggleClass('loading');
        $.ajax({
          type: 'POST',
          url: wpVars.ajaxURL,
          data: {
            action: 'refresh_gallery',
            taxonomy: taxonomy,
            term: term,
          },
        success: function(response){
          //console.log('Done fetching ');
          //console.log(response);
          recipeGallery.html(response);
          const slider = new KeenSlider('.RecipeGallery .keen-slider', {
            loop:true,
            mode:'snap',
            slides: {
                perView: 1,
                spacing: 15,
                origin: 'center',
            },
            breakpoints: {
              "(min-width: 400px)": {
                slides: { perView: 1, spacing: 5 },
              },
              "(min-width: 700px)": {
                slides: { perView: 2, spacing: 15 },
              },
              "(min-width: 1000px)": {
                slides: { perView: 3, spacing: 15 },
              },
              "(min-width: 1200px)": {
                slides: { perView: 4, spacing: 20 },
              },
            }
          },[
            slider => {
                slider.on('created',() =>{
                    const container = slider.container;
                    const prevArrow = container.nextElementSibling;
                    const nextArrow = prevArrow.nextElementSibling;
    
                    prevArrow.addEventListener('click', () => slider.prev());
                    nextArrow.addEventListener('click', () => slider.next());
                })
            }
          ]);
          //console.log(slider);
          recipeGallery.toggleClass('loading');
          //recipeGallery.slick('slickRemove', null, null, true);
          //recipeGallery.slick('slickAdd', response);
          //recipeGallery.toggleClass('loading');
          //
          //fixHeight();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          //console.log(jqXHR);
          // Handle any errors that occur
          console.error('AJAX error: ' + textStatus, errorThrown);
        }
        }
      );
    }

    //Generate HTML so posts can be written to page
    function getItemString(item,posttype){
        let tempHtml = ``;
        let hydHtml = ``;
        switch (posttype) {
          case 'product':
            if(item.flair == null){
              tempHtml = `<figure class="post" data-flair="none">
                            <a aria-description="View product item.title " target="_self" href="item.permalink"> 
                            item.featured_image
                            item.reviews
                            <figcaption>item.title</figcaption>
                            <div class='psuedo-button leaf leaf--light_green text-shadow'>View Product</div>
                            </a>
                          </figure>`;
            } else {
              tempHtml = `<figure class="post flairStyle" data-flair="flair-item.flair">
                            <a aria-description="View product item.title" target="_self" href="item.permalink"> 
                            item.featured_image
                            item.reviews
                            <figcaption>item.title</figcaption>
                            <div class='psuedo-button leaf leaf--light_green text-shadow'>View Product</div>
                            </a>
                          </figure>`;
            }
            break;
          case 'recipe':
            tempHtml = `<figure class="post leaf" data-flair="none">
                            <a aria-description="View product item.title " target="_self" href="item.permalink"> 
                            item.featured_image<figcaption>item.title</figcaption>
                            </a>
                          </figure>`;
            break;
          default:

            break;
        }
        hydHtml = tempHtml.replace(/item\.(\w+)/g, function(match, property) {
          return item[property];
        });
        return hydHtml;
    }

    //CSS Adjustments to grid 
    //Dependent on Product or Recipe
    function setImageHeights(images){
        if(images.length <= 1){
          return;
        }

        switch(outputContainer.attr('data-posttype')){

          case 'product':

                var smallestHeight = null;
            //console.log('setimageheigts');
                images.each(function() {
                  var currentHeight = $(this).height();
                  //console.log(currentHeight);
                  if (smallestHeight === null || currentHeight < smallestHeight) {
                    smallestHeight = currentHeight;
                  }
                });
                
                images.css('height',smallestHeight);
                break;

          case 'recipe':

                var tallestHeight = null;
                
                images.each(function() {
                  var currentHeight = $(this).height();
                  if (tallestHeight === null || currentHeight > tallestHeight) {
                    tallestHeight = currentHeight;
                  }
                });
                
                images.css('height',tallestHeight);
                break;


          default:
            //console.log('Called setImageHeight() in unexpected conditions');
            break;
        }
        
    }

    //Nudge Title of Block up
    let titleHeight = $('.TaxonomyArchive > header').height();
    $('.TaxonomyArchive > header').css('margin-top',-(titleHeight/2));

    //Fix Height, for Recipe Silder update
    // function fixHeight(){
    //   //console.log('fixHeight');
    //   let totalHeight = $('.RecipeGallery figure.leaf').outerHeight();
    //   let tallestElement = 0;
    //   $.each($('.RecipeGallery figure.leaf figcaption'), function () { 
    //       tallestElement = $(this).outerHeight() > tallestElement ? $(this).outerHeight() : tallestElement;
    //       //console.log(tallestElement);
    //   });
    //   $.each($('.RecipeGallery figure.leaf figcaption'), function (){
    //       $(this).css('height',tallestElement);
    //   });
    //   $('.RecipeGallery figure.leaf img').css('height',totalHeight-tallestElement);
    // }

    //AOS.refresh();
    // Check if the element is in the viewport
    // Check if the element is in the viewport
    function isInViewport(element) {
      if(element == null){
        return;
      };
      var rect = element.getBoundingClientRect();
      //console.log(rect);
      //console.log(document.documentElement.clientHeight);
      
      return (
        ($(window).scrollTop() + 5 >= ($(document).height() - window.visualViewport.height))
        ||
        (rect.top < document.documentElement.clientHeight &&
        document.documentElement.clientHeight*0.5 > rect.top)
      )
      // return (
      //   rect.top >= 0 &&
      //   rect.left >= 0 &&
      //   rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      //   rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      // );
    }

    // Function to simulate a click on the load-more button
    function simulateButtonClick(loadMoreButton) {
      //console.log(loadMoreButton.innerText);
        // Replace '#load-more button' with your actual query selector
        setTimeout(()=>{if(loadMoreButton.innerText == 'Load More'){
          loadMoreButton.click();
        }},750);
    }

    // Check if the load-more button is in the viewport and trigger the click event
    window.addEventListener('scroll', function () {
      const loadMoreButton = document.querySelector('#load-more button');
      if (isInViewport(loadMoreButton)) {
        simulateButtonClick(loadMoreButton);
      }
    });


    return (null)
  }

export default taxArcJS